import React from 'react';
import { BiSolidLogOut } from "react-icons/bi";


const CustomModal = ({ isOpen, onClose, onConfirm, title, message }) => {
  if (!isOpen) return null; // Modal is not visible if isOpen is false

  return (
    // <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
    //  
    // >
    //           <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">

    //      <h3 className="text-3xl font-bold mb-4 text-start">{title}</h3>

        
    //      <p className="mb-4 text-start">{message}</p>
    //      <div className="flex justify-end gap-4">
    //                   <button onClick={onClose} className="bg-gray-300 text-black py-3 px-8 rounded-md hover:bg-gray-400 transition duration-200">

    //         No
    //       </button>
    //       <button
    //         
    //       >
    //         Yes
    //       </button>
         
    //     </div>
    //   </div>
    // </div>
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
      <h3 className="text-2xl text-black font-bold mb-4 text-start">{title}</h3>
      <p className="mb-4 text-black text-start">{message}</p>
      <div className="flex justify-end gap-4">
        <button onClick={onClose} className="bg-gray-300 text-black py-3 px-8 rounded-md hover:bg-gray-400 transition duration-200">
          Cancel
        </button>
        <button onClick={onConfirm} className="bg-red-600 text-white py-3 px-8 rounded-md mr-2 hover:bg-red-700 transition duration-200">
          Yes
        </button>
      </div>
    </div>
  </div>
  );
};

export default CustomModal;
